<template>
  <div class="-mt-[100px] bg-light-gray pt-[100px]">
    <div class="p-0 py-10 pt-10 lg:py-24">
      <div class="grid-default px-4 lg:container lg:px-0">
        <div class="col-span-6 lg:col-span-6 lg:col-end-7">
          <Heading
            is-hero-heading
            class="mb-6 text-center text-5xl font-light text-blue lg:mb-0 lg:text-left lg:text-9xl"
            @completed="heroAnimated = true"
          >
            {{ data.title }}
          </Heading>
        </div>
        <div class="col-span-6 lg:col-span-6 lg:col-start-7">
          <div
            class="text-normal-600 mb-6 mt-10 text-center text-base font-light transition-opacity duration-300 lg:mb-0 lg:mt-0 lg:text-left lg:text-2xl"
            :class="heroAnimated ? 'opacity-100' : 'opacity-0'"
            v-html="data.html"
          ></div>
        </div>
      </div>
      <div class="mt-14 flex justify-evenly overflow-hidden lg:mt-48 xl:justify-between">
        <Image
          v-for="(item, index) in data.images"
          :key="index"
          :src="item!.responsiveImage ? item!.responsiveImage?.src : item!.url"
          :srcset="item!.responsiveImage ? item!.responsiveImage?.webpSrcSet : undefined"
          :width="item!.responsiveImage ? item!.responsiveImage?.width : item!.width"
          :height="item!.responsiveImage ? item!.responsiveImage?.height : item!.height"
          :sizes="item?.responsiveImage?.sizes"
          :alt="item!.alt!"
          class="opacity-100 mix-blend-multiply"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { SectionHero3Record } from '~/types/generated'
import { useAppStore } from '~/stores/AppStore'
const store = useAppStore()
const heroAnimated = ref(false)

defineProps({
  data: {
    type: Object as PropType<SectionHero3Record>,
    default: () => {}
  }
})

onMounted(() => {
  store.setTheme('gray')
})
</script>
